import { Icon, type IconName } from '../icon/icon';
import { iconButton } from './icon-button.css';

export interface IconButtonProps {
    icon: IconName;
    /** Required — icon-only controls must carry an accessible name. */
    accessibilityLabel: string;
    disabled?: boolean;
    testID?: string;
    onPress?: () => void | Promise<void>;
}

/** Ghost icon-only button (hover wash, no border) for toolbars and rows. */
export function IconButton({ icon, accessibilityLabel, disabled, testID, onPress }: IconButtonProps) {
    return (
        <button
            type="button"
            className={iconButton}
            aria-label={accessibilityLabel}
            title={accessibilityLabel}
            disabled={disabled}
            data-testid={testID}
            onClick={onPress}
        >
            <Icon name={icon} />
        </button>
    );
}
